/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_UpdateChimesTechnicalInformation } from '../models/BigClock_Api_Models_UpdateChimesTechnicalInformation';
import type { BigClock_Api_Models_WriteChimes } from '../models/BigClock_Api_Models_WriteChimes';
import type { BigClock_Api_Models_WriteChimesTime } from '../models/BigClock_Api_Models_WriteChimesTime';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChimesService {
    /**
     * @param clockStationId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiChimesInfo(
        clockStationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Chimes/{clockStationId}/info',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiChimes(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_WriteChimes,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Chimes/{clockStationId}',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiChimesTime(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_WriteChimesTime,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Chimes/{clockStationId}/time',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiChimesDescriptionTechnical(
        clockStationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Chimes/{clockStationId}/description/technical',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiChimesDescriptionTechnical(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_UpdateChimesTechnicalInformation,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Chimes/{clockStationId}/description/technical',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
